export class UrlPrefixes {
  constructor(public name?: string, public url?: string) {}
}
